import React, { useState } from "react";
import cn from "classnames";
import styles from "./Profile.module.sass";
import { useAuth } from "../../../contexts/AuthContext";
import { updatePartner } from "../../../services/partner.service";
import { showSuccess, showError } from "../../../services/toast.service";
import Icon from "../../../components/Icon";

// Fonction pour formater la date
const formatDate = (dateString) => {
  if (!dateString) return "Non définie";
  const date = new Date(dateString);
  return date.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

// Fonction pour calculer les jours restants
const calculateDaysRemaining = (endDate) => {
  if (!endDate) return null;
  const end = new Date(endDate);
  const now = new Date();
  const diffTime = end - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays > 0 ? diffDays : 0;
};

const Profile = ({ partner }) => {
  const { currentUser } = useAuth();
  const [isUploading, setIsUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  
  // Si aucun partenaire n'est fourni, afficher un message de chargement
  if (!partner) {
    return <div className={styles.profile}>Chargement des données...</div>;
  }

  // Calculer les jours restants pour les comptes démo
  const daysRemaining = partner.demo_account ? calculateDaysRemaining(partner.subscription_end_date) : null;

  // Gestion de l'upload du logo
  const handleFileUpload = async (file) => {
    if (!file) return;

    // Vérifier le type de fichier
    if (!file.type.startsWith('image/')) {
      showError('Veuillez sélectionner un fichier image');
      return;
    }

    // Vérifier la taille (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      showError('Le fichier est trop volumineux (max 5MB)');
      return;
    }

    try {
      setIsUploading(true);
      
      // Créer un FormData pour l'upload
      const formData = new FormData();
      formData.append('logo', file);

      // Mettre à jour le partenaire avec le nouveau logo
      await updatePartner(partner.id, formData);
      showSuccess('Logo mis à jour avec succès');
      
      // Recharger la page pour voir le nouveau logo
      window.location.reload();
    } catch (error) {
      console.error('Erreur lors de l\'upload du logo:', error);
      showError('Erreur lors de la mise à jour du logo');
    } finally {
      setIsUploading(false);
    }
  };

  // Gestion du drag & drop
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUpload(e.dataTransfer.files[0]);
    }
  };

  const handleFileSelect = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFileUpload(e.target.files[0]);
    }
  };

  // Obtenir l'URL du logo
  const getLogoUrl = () => {
    if (partner.logo) {
      // Si c'est déjà une URL complète
      if (partner.logo.startsWith('http')) {
        return partner.logo;
      }
      // Sinon, construire l'URL PocketBase
      return `${process.env.REACT_APP_POCKETBASE_URL}/api/files/partners/${partner.id}/${partner.logo}`;
    }
    return null;
  };

  return (
    <div className={styles.profile}>
      <div className={styles.details}>
        <div className={styles.avatar}>
          <img src={'/images/content/faq_logo.png'} alt="Center Logo" />
        </div>
        <div className={styles.wrap}>
          <div className={cn("h4", styles.man)}>Questions fréquentes</div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
